import { render, staticRenderFns } from "./BookingBaggage.vue?vue&type=template&id=62499dce"
import script from "./BookingBaggage.vue?vue&type=script&lang=js"
export * from "./BookingBaggage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports